"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var header = /*#__PURE__*/(0, _react.css)("width:100%;display:flex;align-items:center;padding:", (0, _util.rem)(12), ";padding-left:", (0, _util.rem)(24), ";cursor:pointer;outline:none;border-bottom:1px solid transparent;transition:border-color 0s 0.3s;svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";transition:all 0.3s;}" + (process.env.NODE_ENV === "production" ? "" : ";label:header;"));

var heading = function heading(theme) {
  return /*#__PURE__*/(0, _react.css)("margin-right:auto;font-size:", theme.fontSize.large, ";font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:heading;"));
};

var active = function active(theme) {
  return /*#__PURE__*/(0, _react.css)("overflow:initial;&>:first-of-type{border-bottom-color:", theme.color.divider, ";transition:border-color 0s;svg{transform:rotate(90deg);}}" + (process.env.NODE_ENV === "production" ? "" : ";label:active;"));
};

var panel = function panel(_ref) {
  var isActive = _ref.isActive,
      theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)(isActive && active(theme), ";margin-bottom:", (0, _util.rem)(8), ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-radius:", (0, _util.rem)(6), ";background-color:", theme.color.monochrome.white, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:panel;"));
};

var styles = {
  header: header,
  heading: heading,
  panel: panel
};
exports.styles = styles;
//# sourceMappingURL=AccordionPanel.styles.js.map